module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/hero-b-35e193e2242b56362c5c75ef2bffbc97.png";